import getOcTheme from '../../theme/services/getOcTheme';
import blockquotes from './blockquotes';
import codes from './codes';
import images from './images';
import videos from './videos';
import semanticBlocks from './semanticBlocks';
import typographies from './typographies';
import lockedContent from './lockedContent';
import tables from './tables';
import math from './math';
import keys from './keys';
import codesandbox from './codesandbox';
import expandableContent from './expandableContent';

const theme = getOcTheme();
const { spacing, palette } = theme as any;

export default {
  root: {
    color: palette.text.onMain,
    '& > *:not(.oc-video)': {
      marginLeft: spacing(2),
      marginRight: spacing(2),
    },
    ...typographies,
    ...blockquotes,
    ...codes,
    ...images,
    ...videos,
    ...semanticBlocks,
    ...lockedContent,
    ...tables,
    ...math,
    ...keys,
    ...codesandbox,
    ...expandableContent,
  },
};
